export default class Switch {
  constructor({ cases = [], ref = '', caseDefault = [] }) {
    this.cases = cases;
    this.caseDefault = caseDefault;
    this.ref = ref;
  }
}
